var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowUpGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "10px",
    viewBox: "0 0 26 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron_Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-3",
    transform: "translate(-620.000000, -269.000000)",
    fill: "#535353",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(-21.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.169654,12.8195674 L657.218989,24.0535144 C657.572188,24.5453712 658.144428,24.5453712 658.498519,24.0535144 C658.851719,23.5616576 658.851719,22.7627535 658.498519,22.2708967 L651.087649,11.9283105 L658.497627,1.58572424 C658.850827,1.09386744 658.850827,0.294963333 658.497627,-0.19813867 C658.144428,-0.689995466 657.571296,-0.689995466 657.218097,-0.19813867 L649.168762,11.0357045 C648.820988,11.5224767 648.820988,12.3339367 649.169654,12.8195674 Z",
    id: "Chevron_Right",
    transform: "translate(653.835731, 11.927688) scale(1, -1) rotate(-90.000000) translate(-653.835731, -11.927688) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpGray);
export default __webpack_public_path__ + "static/media/icArrowUpGray.c3417d3c876e3b0dcc9d0dd87a516ad3.svg";
export { ForwardRef as ReactComponent };